interface StepProgressProps {
  steps: string[];
  currentIndex: number;
}

export function StepProgress({ steps, currentIndex }: StepProgressProps) {
  return (
    <div className="flex items-center gap-1">
      {steps.map((label, i) => (
        <div key={label} className="flex flex-1 flex-col items-center gap-1">
          <div
            className={`h-1 w-full rounded-full transition-colors ${
              i <= currentIndex ? 'bg-brand-500' : 'bg-gray-200'
            }`}
          />
          <span
            className={`text-[10px] ${
              i <= currentIndex ? 'text-brand-600 font-medium' : 'text-gray-400'
            }`}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
